









import { Component, Vue, Prop } from "vue-property-decorator";
import { AddressModel, AddressType } from "../models/address";
import { ListItem } from "shared/global/components/SimpleListCard.vue";

@Component
export default class AddressBlock extends Vue {
  @Prop({ required: true })
  value!: AddressModel;

  get items(): ListItem[] {
    const items = [];
    if (this.value.internal_line)
      items.push({
        label: this.label(`internal`),
        value: this.value.internal_line,
      });
    if (this.value.internal_line2)
      items.push({
        label: "",
        value: this.value.internal_line2,
      });

    items.push(
      ...[
        {
          label: this.label(`address`),
          value: `${this.value.street} ${this.value.house_number}${this.value.house_number_suffix}`,
        },
        {
          label: this.label(`postalCode`),
          value: this.value.postal_code,
        },
        {
          label: this.label(`town`),
          value: this.value.town,
        },
        {
          label: this.label(`country`),
          value: this.value.country,
        },
      ]
    );
    return items;
  }

  get icon(): string {
    switch (this.value.type) {
      case AddressType.business:
        return "building";
      case AddressType.post:
        return "mail-bulk";
      case AddressType.invoice:
        return "file-invoice";
      case AddressType.delivery:
        return "truck";
      default:
        return "building";
    }
  }

  private label(key: string): string {
    return this.$t(
      "relationprofile.components.AddressBlock.labels." + key
    ).toString();
  }

  private title(key: string): string {
    return this.$t(
      "relationprofile.components.AddressBlock.types." + key
    ).toString();
  }
}
